import axios from "axios";
import authHeader from "@/services/auth-header";
import ConstApiUrls from "@/services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL;

class FtRegistrationNeedService {
  getApiUrl() {
    return API_URL;
  }
  getAllFtRegistrationNeed() {
    return axios.get(API_URL + `getAllFtRegistrationNeed`, {
      headers: authHeader(),
    });
  }
  getAllFtRegistrationNeedContaining(page, pageSize, sortBy, order, search) {
    // return axios.get(API_URL + `getAllFtRegistrationNeed`, { headers: authHeaderMultipart() });
    return axios.get(
      API_URL +
        `getAllFtRegistrationNeedContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`,
      { headers: authHeader() }
    );
  }
  getAllFtRegistrationNeedByParent(fmeetingBean) {
    return axios.get(
      API_URL + `getAllFtRegistrationNeedByParent/${fmeetingBean}`,
      {
        headers: authHeader(),
      }
    );
  }
  getAllFtRegistrationNeedByParentPublic(fmeetingBean) {
    return axios.get(
      API_URL + `public/getAllFtRegistrationNeedByParent/${fmeetingBean}`,
      {
        headers: authHeader(),
      }
    );
  }
  getAllFtRegistrationNeedByParentIn(fmeetingBeanIds) {
    return axios.get(
      API_URL + `getAllFtRegistrationNeedByParentIn/${fmeetingBeanIds}`,
      { headers: authHeader() }
    );
  }
  getFtRegistrationNeedById(id) {
    return axios.get(API_URL + `getFtRegistrationNeedById/${id}`, {
      headers: authHeader(),
    });
  }
  updateFtRegistrationNeed(item) {
    return axios.put(API_URL + `updateFtRegistrationNeed/${item.id}`, item, {
      headers: authHeader(),
    });
  }
  createFtRegistrationNeed(item) {
    return axios.post(API_URL + `createFtRegistrationNeed`, item, {
      headers: authHeader(),
    });
  }
  deleteFtRegistrationNeed(id) {
    return axios.delete(API_URL + `deleteFtRegistrationNeed/${id}`, {
      headers: authHeader(),
    });
  }
  deleteAllFtRegistrationNeed(itemIds) {
    // let user = JSON.parse(localStorage.getItem('user'));
    // return axios.delete(API_URL + `deleteAllFtRegistrationNeed`, {
    //     headers:  authHeaderMultipart(),
    //     data: {
    //         message: 'delete  success'
    //     }
    // });
    return axios.delete(API_URL + `deleteAllFtRegistrationNeed`, {
      headers: authHeader(),
      data: itemIds,
    });
  }
}
export default new FtRegistrationNeedService();
